'use strict';

var cov_wdavb1pze = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\photolibrary\\photolibrayCtrl.js',
      hash = 'e02de6678559e0eec58ec5f83c857e9b7f002628',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\photolibrary\\photolibrayCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 279,
          column: 3
        }
      },
      '1': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 37
        }
      },
      '2': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      '3': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 11
        }
      },
      '4': {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 32
        }
      },
      '5': {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 40
        }
      },
      '6': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 39
        }
      },
      '7': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 27
        }
      },
      '8': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 22
        }
      },
      '9': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 20
        }
      },
      '10': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 33,
          column: 4
        }
      },
      '11': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      '12': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      },
      '13': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 43
        }
      },
      '14': {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 74
        }
      },
      '15': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 24
        }
      },
      '16': {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 46,
          column: 4
        }
      },
      '17': {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 41
        }
      },
      '18': {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 72
        }
      },
      '19': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 32
        }
      },
      '20': {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      },
      '21': {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 71,
          column: 7
        }
      },
      '22': {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '23': {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 15
        }
      },
      '24': {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 30
        }
      },
      '25': {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 70,
          column: 9
        }
      },
      '26': {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 33
        }
      },
      '27': {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 67,
          column: 9
        }
      },
      '28': {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 66,
          column: 17
        }
      },
      '29': {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 69
        }
      },
      '30': {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 29
        }
      },
      '31': {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 77,
          column: 4
        }
      },
      '32': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 31
        }
      },
      '33': {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 24
        }
      },
      '34': {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 82,
          column: 4
        }
      },
      '35': {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 25
        }
      },
      '36': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 31
        }
      },
      '37': {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 90,
          column: 4
        }
      },
      '38': {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      },
      '39': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 27
        }
      },
      '40': {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 30
        }
      },
      '41': {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 97,
          column: 4
        }
      },
      '42': {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 96,
          column: 5
        }
      },
      '43': {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 29
        }
      },
      '44': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 32
        }
      },
      '45': {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 137,
          column: 4
        }
      },
      '46': {
        start: {
          line: 99,
          column: 16
        },
        end: {
          line: 99,
          column: 21
        }
      },
      '47': {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 120,
          column: 5
        }
      },
      '48': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 19
        }
      },
      '49': {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 118,
          column: 7
        }
      },
      '50': {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 106,
          column: 9
        }
      },
      '51': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 19
        }
      },
      '52': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 117,
          column: 9
        }
      },
      '53': {
        start: {
          line: 108,
          column: 10
        },
        end: {
          line: 108,
          column: 42
        }
      },
      '54': {
        start: {
          line: 109,
          column: 10
        },
        end: {
          line: 109,
          column: 42
        }
      },
      '55': {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 110,
          column: 97
        }
      },
      '56': {
        start: {
          line: 111,
          column: 10
        },
        end: {
          line: 111,
          column: 48
        }
      },
      '57': {
        start: {
          line: 112,
          column: 10
        },
        end: {
          line: 112,
          column: 42
        }
      },
      '58': {
        start: {
          line: 113,
          column: 10
        },
        end: {
          line: 113,
          column: 42
        }
      },
      '59': {
        start: {
          line: 114,
          column: 10
        },
        end: {
          line: 114,
          column: 42
        }
      },
      '60': {
        start: {
          line: 115,
          column: 10
        },
        end: {
          line: 115,
          column: 42
        }
      },
      '61': {
        start: {
          line: 116,
          column: 10
        },
        end: {
          line: 116,
          column: 16
        }
      },
      '62': {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 119,
          column: 27
        }
      },
      '63': {
        start: {
          line: 122,
          column: 22
        },
        end: {
          line: 122,
          column: 55
        }
      },
      '64': {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 81
        }
      },
      '65': {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 29
        }
      },
      '66': {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 136,
          column: 7
        }
      },
      '67': {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 129,
          column: 7
        }
      },
      '68': {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 15
        }
      },
      '69': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 133,
          column: 7
        }
      },
      '70': {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 33
        }
      },
      '71': {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 15
        }
      },
      '72': {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 39
        }
      },
      '73': {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 27
        }
      },
      '74': {
        start: {
          line: 138,
          column: 21
        },
        end: {
          line: 153,
          column: 3
        }
      },
      '75': {
        start: {
          line: 139,
          column: 14
        },
        end: {
          line: 139,
          column: 15
        }
      },
      '76': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      },
      '77': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 14
        }
      },
      '78': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 25
        }
      },
      '79': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 28
        }
      },
      '80': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 152,
          column: 7
        }
      },
      '81': {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 149,
          column: 7
        }
      },
      '82': {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 41
        }
      },
      '83': {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 31
        }
      },
      '84': {
        start: {
          line: 154,
          column: 21
        },
        end: {
          line: 172,
          column: 3
        }
      },
      '85': {
        start: {
          line: 155,
          column: 14
        },
        end: {
          line: 155,
          column: 15
        }
      },
      '86': {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 160,
          column: 5
        }
      },
      '87': {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 14
        }
      },
      '88': {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 159,
          column: 25
        }
      },
      '89': {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 28
        }
      },
      '90': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 171,
          column: 7
        }
      },
      '91': {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 169,
          column: 7
        }
      },
      '92': {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 164,
          column: 36
        }
      },
      '93': {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 36
        }
      },
      '94': {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 166,
          column: 52
        }
      },
      '95': {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 167,
          column: 63
        }
      },
      '96': {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 168,
          column: 41
        }
      },
      '97': {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 31
        }
      },
      '98': {
        start: {
          line: 174,
          column: 18
        },
        end: {
          line: 180,
          column: 3
        }
      },
      '99': {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 33
        }
      },
      '100': {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 21
        }
      },
      '101': {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      },
      '102': {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 23
        }
      },
      '103': {
        start: {
          line: 182,
          column: 2
        },
        end: {
          line: 201,
          column: 4
        }
      },
      '104': {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 189,
          column: 5
        }
      },
      '105': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 186,
          column: 7
        }
      },
      '106': {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 185,
          column: 15
        }
      },
      '107': {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 26
        }
      },
      '108': {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 199,
          column: 5
        }
      },
      '109': {
        start: {
          line: 191,
          column: 6
        },
        end: {
          line: 191,
          column: 32
        }
      },
      '110': {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 198,
          column: 7
        }
      },
      '111': {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 196,
          column: 9
        }
      },
      '112': {
        start: {
          line: 195,
          column: 10
        },
        end: {
          line: 195,
          column: 16
        }
      },
      '113': {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 29
        }
      },
      '114': {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 18
        }
      },
      '115': {
        start: {
          line: 202,
          column: 2
        },
        end: {
          line: 209,
          column: 4
        }
      },
      '116': {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 208,
          column: 7
        }
      },
      '117': {
        start: {
          line: 210,
          column: 2
        },
        end: {
          line: 213,
          column: 4
        }
      },
      '118': {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 211,
          column: 27
        }
      },
      '119': {
        start: {
          line: 212,
          column: 4
        },
        end: {
          line: 212,
          column: 48
        }
      },
      '120': {
        start: {
          line: 214,
          column: 2
        },
        end: {
          line: 226,
          column: 4
        }
      },
      '121': {
        start: {
          line: 215,
          column: 18
        },
        end: {
          line: 215,
          column: 123
        }
      },
      '122': {
        start: {
          line: 216,
          column: 16
        },
        end: {
          line: 216,
          column: 21
        }
      },
      '123': {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 220,
          column: 5
        }
      },
      '124': {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 92
        }
      },
      '125': {
        start: {
          line: 219,
          column: 6
        },
        end: {
          line: 219,
          column: 19
        }
      },
      '126': {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 225,
          column: 7
        }
      },
      '127': {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 222,
          column: 39
        }
      },
      '128': {
        start: {
          line: 223,
          column: 6
        },
        end: {
          line: 223,
          column: 67
        }
      },
      '129': {
        start: {
          line: 224,
          column: 6
        },
        end: {
          line: 224,
          column: 25
        }
      },
      '130': {
        start: {
          line: 227,
          column: 2
        },
        end: {
          line: 229,
          column: 4
        }
      },
      '131': {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 28
        }
      },
      '132': {
        start: {
          line: 230,
          column: 2
        },
        end: {
          line: 255,
          column: 4
        }
      },
      '133': {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 254,
          column: 7
        }
      },
      '134': {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 244,
          column: 7
        }
      },
      '135': {
        start: {
          line: 243,
          column: 8
        },
        end: {
          line: 243,
          column: 15
        }
      },
      '136': {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 30
        }
      },
      '137': {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 253,
          column: 9
        }
      },
      '138': {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 247,
          column: 33
        }
      },
      '139': {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 250,
          column: 9
        }
      },
      '140': {
        start: {
          line: 249,
          column: 10
        },
        end: {
          line: 249,
          column: 17
        }
      },
      '141': {
        start: {
          line: 251,
          column: 8
        },
        end: {
          line: 251,
          column: 69
        }
      },
      '142': {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 27
        }
      },
      '143': {
        start: {
          line: 256,
          column: 2
        },
        end: {
          line: 256,
          column: 22
        }
      },
      '144': {
        start: {
          line: 258,
          column: 19
        },
        end: {
          line: 262,
          column: 4
        }
      },
      '145': {
        start: {
          line: 263,
          column: 2
        },
        end: {
          line: 267,
          column: 4
        }
      },
      '146': {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 32
        }
      },
      '147': {
        start: {
          line: 265,
          column: 4
        },
        end: {
          line: 265,
          column: 27
        }
      },
      '148': {
        start: {
          line: 266,
          column: 4
        },
        end: {
          line: 266,
          column: 25
        }
      },
      '149': {
        start: {
          line: 268,
          column: 2
        },
        end: {
          line: 272,
          column: 4
        }
      },
      '150': {
        start: {
          line: 269,
          column: 4
        },
        end: {
          line: 269,
          column: 29
        }
      },
      '151': {
        start: {
          line: 270,
          column: 4
        },
        end: {
          line: 270,
          column: 25
        }
      },
      '152': {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 271,
          column: 65
        }
      },
      '153': {
        start: {
          line: 273,
          column: 2
        },
        end: {
          line: 278,
          column: 4
        }
      },
      '154': {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 274,
          column: 29
        }
      },
      '155': {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 276,
          column: 25
        }
      },
      '156': {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 65
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 8,
            column: 53
          },
          end: {
            line: 8,
            column: 54
          }
        },
        loc: {
          start: {
            line: 8,
            column: 178
          },
          end: {
            line: 279,
            column: 1
          }
        },
        line: 8
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 24
          }
        },
        loc: {
          start: {
            line: 19,
            column: 35
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 19
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 42,
            column: 28
          },
          end: {
            line: 42,
            column: 29
          }
        },
        loc: {
          start: {
            line: 42,
            column: 44
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 42
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 24
          }
        },
        loc: {
          start: {
            line: 47,
            column: 39
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 47
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 58,
            column: 7
          },
          end: {
            line: 58,
            column: 8
          }
        },
        loc: {
          start: {
            line: 58,
            column: 20
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 58
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 63,
            column: 84
          },
          end: {
            line: 63,
            column: 85
          }
        },
        loc: {
          start: {
            line: 63,
            column: 92
          },
          end: {
            line: 70,
            column: 7
          }
        },
        line: 63
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 74,
            column: 21
          },
          end: {
            line: 74,
            column: 22
          }
        },
        loc: {
          start: {
            line: 74,
            column: 37
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 74
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 79,
            column: 23
          },
          end: {
            line: 79,
            column: 24
          }
        },
        loc: {
          start: {
            line: 79,
            column: 35
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 79
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 84,
            column: 16
          },
          end: {
            line: 84,
            column: 17
          }
        },
        loc: {
          start: {
            line: 84,
            column: 32
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 84
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 91,
            column: 18
          },
          end: {
            line: 91,
            column: 19
          }
        },
        loc: {
          start: {
            line: 91,
            column: 34
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 91
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 98,
            column: 20
          },
          end: {
            line: 98,
            column: 21
          }
        },
        loc: {
          start: {
            line: 98,
            column: 32
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 98
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 126,
            column: 91
          },
          end: {
            line: 126,
            column: 92
          }
        },
        loc: {
          start: {
            line: 126,
            column: 99
          },
          end: {
            line: 136,
            column: 5
          }
        },
        line: 126
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 138,
            column: 21
          },
          end: {
            line: 138,
            column: 22
          }
        },
        loc: {
          start: {
            line: 138,
            column: 37
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 138
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 146,
            column: 57
          },
          end: {
            line: 146,
            column: 58
          }
        },
        loc: {
          start: {
            line: 146,
            column: 65
          },
          end: {
            line: 152,
            column: 5
          }
        },
        line: 146
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 154,
            column: 21
          },
          end: {
            line: 154,
            column: 22
          }
        },
        loc: {
          start: {
            line: 154,
            column: 37
          },
          end: {
            line: 172,
            column: 3
          }
        },
        line: 154
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 162,
            column: 58
          },
          end: {
            line: 162,
            column: 59
          }
        },
        loc: {
          start: {
            line: 162,
            column: 66
          },
          end: {
            line: 171,
            column: 5
          }
        },
        line: 162
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 174,
            column: 18
          },
          end: {
            line: 174,
            column: 19
          }
        },
        loc: {
          start: {
            line: 174,
            column: 34
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 174
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 182,
            column: 22
          },
          end: {
            line: 182,
            column: 23
          }
        },
        loc: {
          start: {
            line: 182,
            column: 44
          },
          end: {
            line: 201,
            column: 3
          }
        },
        line: 182
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 202,
            column: 24
          },
          end: {
            line: 202,
            column: 25
          }
        },
        loc: {
          start: {
            line: 202,
            column: 36
          },
          end: {
            line: 209,
            column: 3
          }
        },
        line: 202
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 210,
            column: 22
          },
          end: {
            line: 210,
            column: 23
          }
        },
        loc: {
          start: {
            line: 210,
            column: 38
          },
          end: {
            line: 213,
            column: 3
          }
        },
        line: 210
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 214,
            column: 23
          },
          end: {
            line: 214,
            column: 24
          }
        },
        loc: {
          start: {
            line: 214,
            column: 35
          },
          end: {
            line: 226,
            column: 3
          }
        },
        line: 214
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 221,
            column: 124
          },
          end: {
            line: 221,
            column: 125
          }
        },
        loc: {
          start: {
            line: 221,
            column: 132
          },
          end: {
            line: 225,
            column: 5
          }
        },
        line: 221
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 227,
            column: 21
          },
          end: {
            line: 227,
            column: 22
          }
        },
        loc: {
          start: {
            line: 227,
            column: 33
          },
          end: {
            line: 229,
            column: 3
          }
        },
        line: 227
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 230,
            column: 24
          },
          end: {
            line: 230,
            column: 25
          }
        },
        loc: {
          start: {
            line: 230,
            column: 40
          },
          end: {
            line: 255,
            column: 3
          }
        },
        line: 230
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 241,
            column: 7
          },
          end: {
            line: 241,
            column: 8
          }
        },
        loc: {
          start: {
            line: 241,
            column: 20
          },
          end: {
            line: 254,
            column: 5
          }
        },
        line: 241
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 246,
            column: 84
          },
          end: {
            line: 246,
            column: 85
          }
        },
        loc: {
          start: {
            line: 246,
            column: 92
          },
          end: {
            line: 253,
            column: 7
          }
        },
        line: 246
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 263,
            column: 31
          },
          end: {
            line: 263,
            column: 32
          }
        },
        loc: {
          start: {
            line: 263,
            column: 66
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 263
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 268,
            column: 27
          },
          end: {
            line: 268,
            column: 28
          }
        },
        loc: {
          start: {
            line: 268,
            column: 74
          },
          end: {
            line: 272,
            column: 3
          }
        },
        line: 268
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 273,
            column: 25
          },
          end: {
            line: 273,
            column: 26
          }
        },
        loc: {
          start: {
            line: 273,
            column: 72
          },
          end: {
            line: 278,
            column: 3
          }
        },
        line: 273
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        }],
        line: 10
      },
      '1': {
        loc: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }],
        line: 59
      },
      '2': {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 67,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 67,
            column: 9
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 67,
            column: 9
          }
        }],
        line: 65
      },
      '3': {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 89,
            column: 5
          }
        }],
        line: 85
      },
      '4': {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }],
        line: 92
      },
      '5': {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }],
        line: 100
      },
      '6': {
        loc: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }, {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }],
        line: 104
      },
      '7': {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        }],
        line: 107
      },
      '8': {
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        }, {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        }],
        line: 127
      },
      '9': {
        loc: {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        }],
        line: 130
      },
      '10': {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }],
        line: 140
      },
      '11': {
        loc: {
          start: {
            line: 143,
            column: 12
          },
          end: {
            line: 143,
            column: 24
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 143,
            column: 12
          },
          end: {
            line: 143,
            column: 19
          }
        }, {
          start: {
            line: 143,
            column: 23
          },
          end: {
            line: 143,
            column: 24
          }
        }],
        line: 143
      },
      '12': {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        }],
        line: 156
      },
      '13': {
        loc: {
          start: {
            line: 159,
            column: 12
          },
          end: {
            line: 159,
            column: 24
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 159,
            column: 12
          },
          end: {
            line: 159,
            column: 19
          }
        }, {
          start: {
            line: 159,
            column: 23
          },
          end: {
            line: 159,
            column: 24
          }
        }],
        line: 159
      },
      '14': {
        loc: {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        }, {
          start: {
            line: 177,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        }],
        line: 177
      },
      '15': {
        loc: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 189,
            column: 5
          }
        }],
        line: 183
      },
      '16': {
        loc: {
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 186,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 186,
            column: 7
          }
        }, {
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 186,
            column: 7
          }
        }],
        line: 184
      },
      '17': {
        loc: {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        }, {
          start: {
            line: 190,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        }],
        line: 190
      },
      '18': {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 196,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 196,
            column: 9
          }
        }, {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 196,
            column: 9
          }
        }],
        line: 194
      },
      '19': {
        loc: {
          start: {
            line: 205,
            column: 25
          },
          end: {
            line: 205,
            column: 117
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 205,
            column: 69
          },
          end: {
            line: 205,
            column: 113
          }
        }, {
          start: {
            line: 205,
            column: 116
          },
          end: {
            line: 205,
            column: 117
          }
        }],
        line: 205
      },
      '20': {
        loc: {
          start: {
            line: 215,
            column: 18
          },
          end: {
            line: 215,
            column: 123
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 215,
            column: 62
          },
          end: {
            line: 215,
            column: 118
          }
        }, {
          start: {
            line: 215,
            column: 121
          },
          end: {
            line: 215,
            column: 123
          }
        }],
        line: 215
      },
      '21': {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }, {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }],
        line: 217
      },
      '22': {
        loc: {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 244,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 244,
            column: 7
          }
        }, {
          start: {
            line: 242,
            column: 6
          },
          end: {
            line: 244,
            column: 7
          }
        }],
        line: 242
      },
      '23': {
        loc: {
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 250,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 250,
            column: 9
          }
        }, {
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 250,
            column: 9
          }
        }],
        line: 248
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_wdavb1pze.s[0]++;
/**
 * Created by BKSB on 21/03/2017.
 */

/**
 * Created by BKSB on 10/03/2017.
 */
angular.module('app').controller('photolibraryCtrl', function ($scope, SweetAlert, $rootScope, $deltahttp, $translate, $deltadate, $CRUDService, $filter, $deltaLocation, FileUploader) {
  cov_wdavb1pze.f[0]++;
  cov_wdavb1pze.s[1]++;

  $rootScope.processPageRight('5_4');
  cov_wdavb1pze.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_wdavb1pze.b[0][0]++;
    cov_wdavb1pze.s[3]++;

    return;
  } else {
    cov_wdavb1pze.b[0][1]++;
  }
  var PATH_DOC = (cov_wdavb1pze.s[4]++, 'Phototheque');
  var PATH_CLS = (cov_wdavb1pze.s[5]++, 'ClasseurPhototheque');
  cov_wdavb1pze.s[6]++;
  $deltaLocation.addController($scope);
  cov_wdavb1pze.s[7]++;
  $scope.listDataType = [];
  cov_wdavb1pze.s[8]++;
  $scope.listcls = [];
  cov_wdavb1pze.s[9]++;
  $scope.index = -3;
  cov_wdavb1pze.s[10]++;
  $scope.addnewphoto = function () {
    cov_wdavb1pze.f[1]++;
    cov_wdavb1pze.s[11]++;

    $scope.editPhoto({
      CODE_L: $scope.listData_bksb[0],
      PUBLIC: false,
      DATE_PHOTO: Date.newDate(),
      DESCRIPTE: '',
      id: 0,
      ID_CLS_PHOTO: $scope.listcls[$scope.listcls.length - 1].id,
      REFERENCE: '',
      RESUME: '',
      AUTEUR: '',
      GPSLAT: 0,
      GPSLON: 0
    });
  };
  cov_wdavb1pze.s[12]++;
  $scope.location = {
    selected: function selected(item) {
      cov_wdavb1pze.s[13]++;

      $scope.selectedItem.CODE_L = item.id;
      cov_wdavb1pze.s[14]++;
      $scope.selectedItem.Lieu = item.CODE_LC + ': ' + item.DESCRIPTION_L;
      cov_wdavb1pze.s[15]++;
      this.open = false;
    },

    open: false
  };
  cov_wdavb1pze.s[16]++;
  $scope.selectedLocation = function (item) {
    cov_wdavb1pze.f[2]++;
    cov_wdavb1pze.s[17]++;

    $scope.selectedItem.CODE_L = item.id;
    cov_wdavb1pze.s[18]++;
    $scope.selectedItem.Lieu = item.CODE_LC + ': ' + item.DESCRIPTION_L;
    cov_wdavb1pze.s[19]++;
    $scope.openlocation = false;
  };
  cov_wdavb1pze.s[20]++;
  $scope.deletePhoto = function (item) {
    cov_wdavb1pze.f[3]++;
    cov_wdavb1pze.s[21]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('PHOTOLIBRARY.CONFIRM_DELETE_PHOTO'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_wdavb1pze.f[4]++;
      cov_wdavb1pze.s[22]++;

      if (!isconfirm) {
        cov_wdavb1pze.b[1][0]++;
        cov_wdavb1pze.s[23]++;

        return;
      } else {
        cov_wdavb1pze.b[1][1]++;
      }
      cov_wdavb1pze.s[24]++;
      $scope.isloading = true;
      cov_wdavb1pze.s[25]++;
      $CRUDService.delet(PATH_DOC, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
        cov_wdavb1pze.f[5]++;
        cov_wdavb1pze.s[26]++;

        $scope.isloading = false;
        cov_wdavb1pze.s[27]++;
        if (data < 1) {
          cov_wdavb1pze.b[2][0]++;
          cov_wdavb1pze.s[28]++;

          return;
        } else {
          cov_wdavb1pze.b[2][1]++;
        }
        cov_wdavb1pze.s[29]++;
        $scope.gotoFolder($scope.listcls[$scope.listcls.length - 1]);
        cov_wdavb1pze.s[30]++;
        $scope.cancelPhoto();
      });
    });
  };

  cov_wdavb1pze.s[31]++;
  $scope.editPhoto = function (item) {
    cov_wdavb1pze.f[6]++;
    cov_wdavb1pze.s[32]++;

    $scope.selectedItem = item;
    cov_wdavb1pze.s[33]++;
    $scope.isadd = true;
  };

  cov_wdavb1pze.s[34]++;
  $scope.cancelPhoto = function () {
    cov_wdavb1pze.f[7]++;
    cov_wdavb1pze.s[35]++;

    $scope.isadd = false;
    cov_wdavb1pze.s[36]++;
    $scope.selectedItem = null;
  };

  cov_wdavb1pze.s[37]++;
  $scope.edit = function (item) {
    cov_wdavb1pze.f[8]++;
    cov_wdavb1pze.s[38]++;

    if (item.ID_CLS_PHOTO) {
      cov_wdavb1pze.b[3][0]++;
      cov_wdavb1pze.s[39]++;

      this.editPhoto(item);
    } else {
      cov_wdavb1pze.b[3][1]++;
      cov_wdavb1pze.s[40]++;

      $scope.editfolder(item);
    }
  };
  cov_wdavb1pze.s[41]++;
  $scope.delete = function (item) {
    cov_wdavb1pze.f[9]++;
    cov_wdavb1pze.s[42]++;

    if (item.ID_CLS_PHOTO) {
      cov_wdavb1pze.b[4][0]++;
      cov_wdavb1pze.s[43]++;

      this.deletePhoto(item);
    } else {
      cov_wdavb1pze.b[4][1]++;
      cov_wdavb1pze.s[44]++;

      $scope.deletefolder(item);
    }
  };
  cov_wdavb1pze.s[45]++;
  $scope.validate = function () {
    cov_wdavb1pze.f[10]++;

    var isnew = (cov_wdavb1pze.s[46]++, false);
    cov_wdavb1pze.s[47]++;
    if (!$scope.selectedItem.id) {
      cov_wdavb1pze.b[5][0]++;
      cov_wdavb1pze.s[48]++;

      isnew = true;
    } else {
      cov_wdavb1pze.b[5][1]++;
      cov_wdavb1pze.s[49]++;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = $scope.listDataDocument[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;
          cov_wdavb1pze.s[50]++;

          if (!el.ID_CLS_PHOTO) {
            cov_wdavb1pze.b[6][0]++;
            cov_wdavb1pze.s[51]++;

            continue;
          } else {
            cov_wdavb1pze.b[6][1]++;
          }
          cov_wdavb1pze.s[52]++;
          if (el.id == selectedItem.id) {
            cov_wdavb1pze.b[7][0]++;
            cov_wdavb1pze.s[53]++;

            el.CODE_L = selectedItem.CODE_L;
            cov_wdavb1pze.s[54]++;
            el.PUBLIC = selectedItem.PUBLIC;
            cov_wdavb1pze.s[55]++;
            el.DATE_PHOTO = Date.newDate($deltadate.format(selectedItem.DATE_PHOTO, 'yyyy-mm-dd'));
            cov_wdavb1pze.s[56]++;
            el.DESCRIPTE = selectedItem.DESCRIPTE;
            cov_wdavb1pze.s[57]++;
            el.RESUME = selectedItem.RESUME;
            cov_wdavb1pze.s[58]++;
            el.AUTEUR = selectedItem.AUTEUR;
            cov_wdavb1pze.s[59]++;
            el.GPSLAT = selectedItem.GPSLAT;
            cov_wdavb1pze.s[60]++;
            el.GPSLON = selectedItem.GPSLON;
            cov_wdavb1pze.s[61]++;
            break;
          } else {
            cov_wdavb1pze.b[7][1]++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      cov_wdavb1pze.s[62]++;
      $scope.isadd = false;
    }

    var valueData = (cov_wdavb1pze.s[63]++, angular.copy($scope.selectedItem));
    cov_wdavb1pze.s[64]++;
    valueData.DATE_PHOTO = $deltadate.format(valueData.DATE_PHOTO, 'yyyy-mm-dd');

    cov_wdavb1pze.s[65]++;
    $scope.isloading = isnew;
    cov_wdavb1pze.s[66]++;
    $CRUDService.save(PATH_DOC, { action: 'MiseAJour', valeur: $filter('json')(valueData) }, function (data) {
      cov_wdavb1pze.f[11]++;
      cov_wdavb1pze.s[67]++;

      if (!isnew) {
        cov_wdavb1pze.b[8][0]++;
        cov_wdavb1pze.s[68]++;

        return;
      } else {
        cov_wdavb1pze.b[8][1]++;
      }
      cov_wdavb1pze.s[69]++;
      if (data < 1) {
        cov_wdavb1pze.b[9][0]++;
        cov_wdavb1pze.s[70]++;

        $scope.isloading = false;
        cov_wdavb1pze.s[71]++;
        return;
      } else {
        cov_wdavb1pze.b[9][1]++;
      }
      cov_wdavb1pze.s[72]++;
      $scope.file.url += '&id=' + data;
      cov_wdavb1pze.s[73]++;
      $scope.file.upload();
    });
  };
  cov_wdavb1pze.s[74]++;
  var _getAllCls = function _getAllCls(item) {
    cov_wdavb1pze.f[12]++;

    var idP = (cov_wdavb1pze.s[75]++, 0);
    cov_wdavb1pze.s[76]++;
    if (!item) {
      cov_wdavb1pze.b[10][0]++;
      cov_wdavb1pze.s[77]++;

      idP = 0;
    } else {
      cov_wdavb1pze.b[10][1]++;
      cov_wdavb1pze.s[78]++;

      idP = (cov_wdavb1pze.b[11][0]++, item.id) || (cov_wdavb1pze.b[11][1]++, 0);
    }
    cov_wdavb1pze.s[79]++;
    $scope.isloading = true;
    cov_wdavb1pze.s[80]++;
    $CRUDService.getAll(PATH_CLS, { get: 'all', id: idP }, function (data) {
      cov_wdavb1pze.f[13]++;
      cov_wdavb1pze.s[81]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el = _step2.value;
          cov_wdavb1pze.s[82]++;

          $scope.listDataDocument.push(el);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      cov_wdavb1pze.s[83]++;
      $scope.isloading = false;
      // $scope.listcls=data;
    });
  };
  cov_wdavb1pze.s[84]++;
  var _getAllDoc = function _getAllDoc(item) {
    cov_wdavb1pze.f[14]++;

    var idP = (cov_wdavb1pze.s[85]++, 0);
    cov_wdavb1pze.s[86]++;
    if (!item) {
      cov_wdavb1pze.b[12][0]++;
      cov_wdavb1pze.s[87]++;

      idP = 0;
    } else {
      cov_wdavb1pze.b[12][1]++;
      cov_wdavb1pze.s[88]++;

      idP = (cov_wdavb1pze.b[13][0]++, item.id) || (cov_wdavb1pze.b[13][1]++, 0);
    }
    cov_wdavb1pze.s[89]++;
    $scope.isloading = true;
    cov_wdavb1pze.s[90]++;
    $CRUDService.getAll(PATH_DOC, { get: 'all', cls: idP }, function (data) {
      cov_wdavb1pze.f[15]++;
      cov_wdavb1pze.s[91]++;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var el = _step3.value;
          cov_wdavb1pze.s[92]++;

          el.GPSLAT = eval(el.GPSLAT);
          cov_wdavb1pze.s[93]++;
          el.GPSLON = eval(el.GPSLON);
          cov_wdavb1pze.s[94]++;
          el.DATE_PHOTO = Date.newDate(el.DATE_PHOTO);
          cov_wdavb1pze.s[95]++;
          el.img = $deltahttp.getphotolibrary() + el.id + '.jpg';
          cov_wdavb1pze.s[96]++;
          $scope.listDataDocument.push(el);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      cov_wdavb1pze.s[97]++;
      $scope.isloading = false;
    });
  };

  cov_wdavb1pze.s[98]++;
  var _getAll = function _getAll(item) {
    cov_wdavb1pze.f[16]++;
    cov_wdavb1pze.s[99]++;

    $scope.listDataDocument = [];
    cov_wdavb1pze.s[100]++;
    _getAllCls(item);
    cov_wdavb1pze.s[101]++;
    if (item) {
      cov_wdavb1pze.b[14][0]++;
      cov_wdavb1pze.s[102]++;

      _getAllDoc(item);
    } else {
      cov_wdavb1pze.b[14][1]++;
    }
  };

  cov_wdavb1pze.s[103]++;
  $scope.gotoFolder = function (item, type) {
    cov_wdavb1pze.f[17]++;
    cov_wdavb1pze.s[104]++;

    if (item) {
      cov_wdavb1pze.b[15][0]++;
      cov_wdavb1pze.s[105]++;

      if (item.ID_CLS_PHOTO) {
        cov_wdavb1pze.b[16][0]++;
        cov_wdavb1pze.s[106]++;

        return;
      } else {
        cov_wdavb1pze.b[16][1]++;
      }
    } else {
      cov_wdavb1pze.b[15][1]++;
      cov_wdavb1pze.s[107]++;

      $scope.listcls = [];
    }
    cov_wdavb1pze.s[108]++;
    if (type) {
      cov_wdavb1pze.b[17][0]++;
      cov_wdavb1pze.s[109]++;
      // ajouter à la liste
      $scope.listcls.push(item);
    } else {
      cov_wdavb1pze.b[17][1]++;
      cov_wdavb1pze.s[110]++;
      // Retirer de la liste
      for (var i = $scope.listcls.length - 1; i >= 0; i--) {
        cov_wdavb1pze.s[111]++;

        if (item.id == $scope.listcls[i].id) {
          cov_wdavb1pze.b[18][0]++;
          cov_wdavb1pze.s[112]++;

          break;
        } else {
          cov_wdavb1pze.b[18][1]++;
        }
        cov_wdavb1pze.s[113]++;
        $scope.listcls.pop();
      }
    }
    cov_wdavb1pze.s[114]++;
    _getAll(item);
  };
  cov_wdavb1pze.s[115]++;
  $scope.addnewfolder = function () {
    cov_wdavb1pze.f[18]++;
    cov_wdavb1pze.s[116]++;

    this.editfolder({
      CODE_CLS_PHOTO: '',
      ID_PERE_CLS_PHOTO: $scope.listcls[$scope.listcls.length - 1] ? (cov_wdavb1pze.b[19][0]++, $scope.listcls[$scope.listcls.length - 1].id) : (cov_wdavb1pze.b[19][1]++, 0),
      LABEL_CLS_PHOTO: '',
      LEVEL_CLS_PHOTO: $scope.listcls.length + 1
    });
  };
  cov_wdavb1pze.s[117]++;
  $scope.editfolder = function (item) {
    cov_wdavb1pze.f[19]++;
    cov_wdavb1pze.s[118]++;

    $scope.isaddcls = true;
    cov_wdavb1pze.s[119]++;
    $scope.selectedItemCls = angular.copy(item);
  };
  cov_wdavb1pze.s[120]++;
  $scope.validatecls = function () {
    cov_wdavb1pze.f[20]++;

    var codeP = (cov_wdavb1pze.s[121]++, $scope.listcls[$scope.listcls.length - 1] ? (cov_wdavb1pze.b[20][0]++, $scope.listcls[$scope.listcls.length - 1].CODE_CLS_PHOTO) : (cov_wdavb1pze.b[20][1]++, ''));
    var isnew = (cov_wdavb1pze.s[122]++, false);
    cov_wdavb1pze.s[123]++;
    if ($scope.selectedItemCls.id == 0) {
      cov_wdavb1pze.b[21][0]++;
      cov_wdavb1pze.s[124]++;

      $scope.selectedItemCls.CODE_CLS_PHOTO = codeP + $scope.selectedItemCls.CODE_CLS_PHOTO;
      cov_wdavb1pze.s[125]++;
      isnew = true;
    } else {
      cov_wdavb1pze.b[21][1]++;
    }
    cov_wdavb1pze.s[126]++;
    $CRUDService.save(PATH_CLS, { action: 'MiseAJour', Code_Parent: codeP, valeur: $filter('json')($scope.selectedItemCls) }, function (data) {
      cov_wdavb1pze.f[21]++;
      cov_wdavb1pze.s[127]++;

      $scope.selectedItemCls.id = data;
      cov_wdavb1pze.s[128]++;
      $scope.gotoFolder($scope.listcls[$scope.listcls.length - 1]);
      cov_wdavb1pze.s[129]++;
      $scope.cancelcls();
    });
  };
  cov_wdavb1pze.s[130]++;
  $scope.cancelcls = function () {
    cov_wdavb1pze.f[22]++;
    cov_wdavb1pze.s[131]++;

    $scope.isaddcls = false;
  };
  cov_wdavb1pze.s[132]++;
  $scope.deletefolder = function (item) {
    cov_wdavb1pze.f[23]++;
    cov_wdavb1pze.s[133]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('DOCUMENT.CONFIRM_DELETE_FOLDER'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_wdavb1pze.f[24]++;
      cov_wdavb1pze.s[134]++;

      if (!isconfirm) {
        cov_wdavb1pze.b[22][0]++;
        cov_wdavb1pze.s[135]++;

        return;
      } else {
        cov_wdavb1pze.b[22][1]++;
      }
      cov_wdavb1pze.s[136]++;
      $scope.isloading = true;
      cov_wdavb1pze.s[137]++;
      $CRUDService.delet(PATH_CLS, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
        cov_wdavb1pze.f[25]++;
        cov_wdavb1pze.s[138]++;

        $scope.isloading = false;
        cov_wdavb1pze.s[139]++;
        if (data < 1) {
          cov_wdavb1pze.b[23][0]++;
          cov_wdavb1pze.s[140]++;

          return;
        } else {
          cov_wdavb1pze.b[23][1]++;
        }
        cov_wdavb1pze.s[141]++;
        $scope.gotoFolder($scope.listcls[$scope.listcls.length - 1]);
        cov_wdavb1pze.s[142]++;
        $scope.cancelcls();
      });
    });
  };
  cov_wdavb1pze.s[143]++;
  $scope.gotoFolder();

  var uploader = (cov_wdavb1pze.s[144]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'data/web_server.php?action=loadFile&method=1&' + $CRUDService.getComplement(0, PATH_DOC),
    alias: 'photo',
    removeAfterUpload: true
  }));
  cov_wdavb1pze.s[145]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_wdavb1pze.f[26]++;
    cov_wdavb1pze.s[146]++;

    fileItem.url = uploader.url; // +"&indic="+fileItem.indic.id;
    cov_wdavb1pze.s[147]++;
    $scope.file = fileItem;
    cov_wdavb1pze.s[148]++;
    $scope.addnewphoto();
  };
  cov_wdavb1pze.s[149]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_wdavb1pze.f[27]++;
    cov_wdavb1pze.s[150]++;

    $scope.isloading = false;
    cov_wdavb1pze.s[151]++;
    $scope.cancelPhoto();
    cov_wdavb1pze.s[152]++;
    $scope.gotoFolder($scope.listcls[$scope.listcls.length - 1]);
  };
  cov_wdavb1pze.s[153]++;
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    cov_wdavb1pze.f[28]++;
    cov_wdavb1pze.s[154]++;

    $scope.isloading = false;

    cov_wdavb1pze.s[155]++;
    $scope.cancelPhoto();
    cov_wdavb1pze.s[156]++;
    $scope.gotoFolder($scope.listcls[$scope.listcls.length - 1]);
  };
});